import { Instagram, Youtube, Mail } from "lucide-react";
import LogoMark from "@/components/LogoMark";
import { scrollToId } from "@/lib/scroll";
import { RUBRICS } from "@/data/content";

export default function Footer() {
  return (
    <footer className="bg-ink border-t border-ink-border px-5 md:px-10 pt-16 md:pt-24 pb-8 overflow-hidden">
      <div className="grid grid-cols-1 md:grid-cols-12 gap-10 mb-16">
        <div className="md:col-span-5">
          <div className="flex items-center gap-3 mb-5">
            <LogoMark className="h-10 w-10" />
            <span className="font-serif text-lg tracking-[0.3em] uppercase">
              Stillwater
            </span>
          </div>
          <p className="max-w-xs text-sm text-mist leading-relaxed">
            Giornale indipendente di carpfishing. Rubriche video, interviste
            e sessioni: dalla riva, senza filtri.
          </p>
          <div className="mt-6 flex gap-3">
            {[
              { icon: Instagram, label: "Instagram", id: "footer-instagram" },
              { icon: Youtube, label: "YouTube", id: "footer-youtube" },
              { icon: Mail, label: "Email", id: "footer-mail" },
            ].map(({ icon: Icon, label, id }) => (
              <a
                key={id}
                data-testid={id}
                href="mailto:redazione@stillwater.it"
                aria-label={label}
                className="p-3 border border-ink-border rounded-full text-mist hover:text-ember hover:border-ember transition-colors duration-300"
              >
                <Icon size={16} strokeWidth={1.5} />
              </a>
            ))}
          </div>
        </div>

        <div className="md:col-span-3 md:col-start-7">
          <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-faint mb-5">
            Rubriche
          </p>
          <ul className="space-y-3">
            {RUBRICS.map((r) => (
              <li key={r.id}>
                <button
                  data-testid={`footer-rubric-${r.id}`}
                  onClick={() => scrollToId("rubriche")}
                  className="font-serif italic text-lg text-mist hover:text-ember transition-colors duration-300"
                >
                  {r.title}
                </button>
              </li>
            ))}
          </ul>
        </div>

        <div className="md:col-span-3">
          <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-faint mb-5">
            Indice
          </p>
          <ul className="space-y-3">
            {[
              { label: "I numeri", id: "numeri", testid: "footer-nav-numeri" },
              { label: "Manifesto", id: "manifesto", testid: "footer-nav-manifesto" },
              { label: "Il Diario", id: "diario", testid: "footer-nav-diario" },
            ].map((l) => (
              <li key={l.id}>
                <button
                  data-testid={l.testid}
                  onClick={() => scrollToId(l.id)}
                  className="font-serif italic text-lg text-mist hover:text-ember transition-colors duration-300"
                >
                  {l.label}
                </button>
              </li>
            ))}
          </ul>
        </div>
      </div>

      <div
        data-testid="footer-wordmark"
        className="select-none text-center"
      >
        <div className="font-serif font-light uppercase leading-[0.85] tracking-[0.08em] text-[clamp(2.6rem,10.5vw,9rem)] text-bone/15">
          Stillwater
        </div>
        <svg
          viewBox="0 0 400 16"
          className="w-56 md:w-80 mx-auto mt-3 text-bone/25"
          fill="none"
          aria-hidden="true"
        >
          <path d="M0 6h400" stroke="currentColor" strokeWidth="1" />
          <path
            d="M148 10c16-2.6 36-2.6 52 0s36 2.6 52 0"
            stroke="currentColor"
            strokeWidth="1.2"
          />
          <path
            d="M172 14c9-1.6 19-1.6 28 0"
            stroke="currentColor"
            strokeWidth="1"
          />
        </svg>
      </div>

      <div className="mt-10 flex flex-col md:flex-row items-center justify-between gap-3 border-t border-ink-border pt-6 font-mono text-[9px] uppercase tracking-[0.3em] text-faint">
        <span>© MMXXVI Acque Oscure</span>
        <span className="flex items-center gap-2">
          Fatto in riva, non in ufficio
          <span className="text-ember">✳</span>
        </span>
      </div>
    </footer>
  );
}
